var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock_svg__Lock",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".lock_svg__st0{fill:#5298f4}.lock_svg__st1{fill:#394954}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock_svg__Lock_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock_svg__Lock_2_",
    transform: "matrix(.69 0 0 .69 186 186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__st0",
    d: "M624 909.6v73.2c42-4.8 79.2-21.6 110.4-45.6l-51.6-51.6c-16.8 12-37.2 20.4-58.8 24zM814.8 792h-73.2c-3.6 21.6-12 42-24 58.8l51.6 51.6c25.2-31.2 42-69.6 45.6-110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__st1",
    d: "M420 348c0-99.6 80.4-180 180-180s180 80.4 180 180v80.4c26.4 14.4 50.4 31.2 72 50.4V348c0-139.2-112.8-252-252-252S348 208.8 348 348v130.8c21.6-20.4 45.6-36 72-50.4V348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__st0",
    d: "M624 627.6c21.6 3.6 42 12 58.8 24l51.6-51.6c-31.2-25.2-69.6-42-110.4-45.6v73.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lock_svg__st1",
    cx: 600,
    cy: 768,
    r: 66.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__st0",
    d: "M814.8 744c-4.8-42-21.6-79.2-45.6-110.4l-51.6 51.6c12 16.8 20.4 37.2 24 58.8h73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__st1",
    d: "M600 432c-184.8 0-336 151.2-336 336s151.2 336 336 336 336-151.2 336-336-151.2-336-336-336zm188.4 520.8c-1.2 0-1.2 1.2-1.2 1.2l-1.2 1.2c-48 48-114 76.8-186 76.8s-138-28.8-184.8-75.6c0-1.2-1.2-1.2-1.2-1.2-1.2 0-1.2-1.2-1.2-1.2-48-48-76.8-114-76.8-186s28.8-138 75.6-184.8c1.2 0 1.2-1.2 1.2-1.2 0-1.2 1.2-1.2 1.2-1.2 48-48 114-76.8 186-76.8s138 28.8 184.8 75.6c0 1.2 1.2 1.2 1.2 1.2 1.2 0 1.2 1.2 1.2 1.2 48 48 76.8 114 76.8 186s-28.8 138-75.6 184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__st0",
    d: "M576 626.4v-73.2c-42 4.8-79.2 21.6-110.4 45.6l51.6 51.6c16.8-12 37.2-20.4 58.8-24zM576 908.4c-21.6-3.6-42-12-58.8-25.2L465.6 936c31.2 25.2 69.6 42 110.4 45.6v-73.2zM385.2 792c4.8 42 21.6 79.2 45.6 110.4l51.6-51.6c-12-16.8-20.4-37.2-24-58.8h-73.2zM432 633.6c-25.2 31.2-42 69.6-45.6 110.4h73.2c2.4-21.6 10.8-42 22.8-58.8L432 633.6z"
  })))));
};

export default SvgLock;